import { DateRange } from '@mui/x-date-pickers-pro';
import { PickersShortcutsItem } from '@mui/x-date-pickers';
import { TFunction } from 'i18next';
import { Locale } from 'date-fns';
import { enGB, hu, sk, ro, srLatn, hr, cs, sl, it } from 'date-fns/locale';

import availableLanguagesRaw from './availableLanguages.json';

export type Language = {
  code: string;
  name: string;
  order: number;
  original: string;
};

export function getLocale(currentLanguage: string): Locale {
  const languages: string[] = getAvailableLanguages().map((l) => l.code);

  if (!languages.includes(currentLanguage)) {
    return enGB;
  }

  switch (currentLanguage) {
    case 'en':
      return enGB;
    case 'hu':
      return hu;
    case 'sk':
      return sk;
    case 'ro':
      return ro;
    case 'sr':
      return srLatn;
    case 'hr':
      return hr;
    case 'cz':
      return cs;
    case 'sl':
      return sl;
    case 'it':
      return it;
    default:
      return enGB;
  }
}

export function getAvailableLanguages(): Language[] {
  const availableLanguages = availableLanguagesRaw satisfies Language[];
  availableLanguages.sort((a: Language, b: Language) => a.order - b.order);
  return availableLanguages;
}

export function translate(items: PickersShortcutsItem<DateRange<Date>>[], t: TFunction) {
  return items.map((i) => ({
    ...i,
    label: t(i.label),
  }));
}
